import { X_STEP_UP, Y_STEP_UP } from 'constants/map';
import { Point } from '../../types';
import { pathFinder } from '../path-finder';
import { Direction, PathFinderParams } from '../types';
import {
    checkInBetweenNodesInXDirection,
    checkInBetweenNodesInYDirection,
    getDirection,
    getNodesList,
    moveHorizontal,
    moveVertical
} from '../utils';

export const straightPathFinder = ({ source, target, stations, pathNodeList, isLoopBackPath, prevDirection }: PathFinderParams) => {
    const direction: Direction = getDirection({ source, target });
    const stationNodeList = getNodesList(stations);
    const commonRecursionParams = {
        target,
        stations,
        isLoopBackPath,
        pathNodeList
    };

    // If there is any station in between two points then move in the prev direction first if exist
    if (prevDirection?.x && checkInBetweenNodesInYDirection({ source, target, direction, nodeList: stationNodeList })) {
        const newPoint = moveHorizontal(source, prevDirection.x);
        return [source, newPoint].concat(pathFinder({ source: newPoint, prevDirection, ...commonRecursionParams }).slice(1));
    }

    // If there is any station in between two points in the same direction
    if (
        (source.y === target.y && checkInBetweenNodesInXDirection({ source, target, direction, nodeList: stationNodeList })) ||
        (source.x === target.x && checkInBetweenNodesInYDirection({ source, target, direction, nodeList: stationNodeList }))
    ) {
        const checkInBetweenNodeFunction = source.y === target.y ? checkInBetweenNodesInXDirection : checkInBetweenNodesInYDirection;
        const moveFunction = source.y === target.y ? moveVertical : moveHorizontal;

        const initialDirection = checkInBetweenNodeFunction({
            source: moveFunction(source, 1),
            target,
            direction,
            nodeList: pathNodeList,
            count: 1
        })
            ? -1
            : 1;
        try {
            let point: Point;
            const path = [source];
            do {
                point = moveFunction(path[path.length - 1], initialDirection);
                path.push(point);
            } while (
                checkInBetweenNodeFunction({ source: point, target, direction, nodeList: stationNodeList }) ||
                checkInBetweenNodeFunction({ source: point, target, direction, nodeList: pathNodeList, count: 2 })
            );
            return path.concat(pathFinder({ source: path[path.length - 1], ...commonRecursionParams }).slice(1));
        } catch (error) {
            try {
                let point: Point;
                const path = [source];
                do {
                    point = moveFunction(path[path.length - 1], -initialDirection);
                    path.push(point);
                } while (
                    checkInBetweenNodeFunction({ source: point, target, direction, nodeList: stationNodeList }) ||
                    checkInBetweenNodeFunction({ source: point, target, direction, nodeList: pathNodeList, count: 2 })
                );
                return path.concat(pathFinder({ source: path[path.length - 1], ...commonRecursionParams }).slice(1));
            } catch (error) {
                return [source];
            }
        }
    }

    return [
        source,
        ...(direction.x !== 0
            ? Array.from({ length: Math.abs(target.x - source.x) / X_STEP_UP }, (_, i) =>
                  moveHorizontal(source, direction.x, i * X_STEP_UP)
              ).slice(1)
            : Array.from({ length: Math.abs(target.y - source.y) / Y_STEP_UP }, (_, i) =>
                  moveVertical(source, direction.y, i * Y_STEP_UP)
              ).slice(1)),
        target
    ];
};
